import React, {useState} from 'react'
import styles from './index.module.css'
import { IconInfoCircle } from '@tabler/icons-react';
import { Modal, Card, Button } from 'react-onsenui';

const BookmarkInfoButton = () => {

    const [modalOpen, setModalOpen] = useState(false)

    return (
        <>
            <div className={styles.infoButtonWrapper}>
                <button
                    className={styles.infoButton}
                    onClick={() => setModalOpen(true)}
                >
                    <IconInfoCircle/>
                </button>
            </div>

            <Modal visible={modalOpen}>
                <Card class={styles.body}>
                    <div className={styles.text}>
                        <p>Bookmark this webpage to access the Scanner quickly</p>
                        <p>Share this URL with your employee, so they can scan tickets too</p>
                    </div>

                    <Button
                        class={styles.okButton}
                        onClick={() => setModalOpen(false)}
                    >
                        OK
                    </Button>
                </Card>
            </Modal>
        </>
    )
}

export default BookmarkInfoButton
